// extracted by mini-css-extract-plugin
export default {"toastRoot":"xFh-T","toastContainer":"aeoz-","toastIcon":"Dc-pX","text":"_1oAwb","skeleton-progress":"FvZGd"};